import { render } from "./CheckComponentEditor.vue?vue&type=template&id=e6e2ed3c&scoped=true"
import script from "./CheckComponentEditor.vue?vue&type=script&lang=ts"
export * from "./CheckComponentEditor.vue?vue&type=script&lang=ts"

import "./CheckComponentEditor.vue?vue&type=style&index=0&id=e6e2ed3c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e6e2ed3c"

export default script